import React from 'react'
import logo from './images/logo.png'
import { Outlet, useNavigate } from 'react-router-dom'
import back from './images/back.jpg'
export default function Header() {
    const navigate=useNavigate()
  return (
    <div>
         <nav class="navbar  navbar-expand-lg navbar-light bg-light" >
      <a class="navbar-brand" href="/"><img width="80" height="70" class="d-inline-block align-top" src={logo} alt="logo" /></a>
      <button onClick={() => navigate(-1)}> <img width="50" height="40" class="d-inline-block align-top justify-end"  src={back}/> </button> 
    </nav>
    </div>
  )
}
